/** @format */

import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import { getContentItems } from 'src/slices/topics';
import { useDispatch, useSelector } from 'src/store';
import { collectUniqueTagLabels } from 'src/utils/administration';

export default function TagsAdminPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contentItems, contentItemsLoading } = useSelector(state => state.topics);

  useEffect(() => {
    dispatch(
      getContentItems({
        activeTopicBrand: 'all',
        selectedLanguage: 'Select Language',
        selectedSortBy: 'Sort by'
      })
    );
  }, [dispatch]);

  const tagList = useMemo(() => {
    const labels = collectUniqueTagLabels(contentItems);
    return [...labels].sort((a, b) => a.localeCompare(b));
  }, [contentItems]);

  return (
    <Page className="administration-tags-page" title={t('administrationPage.tagsTitle')}>
      <Breadcrumb
        data={[
          { title: t('administrationPage.title'), link: '/administration' },
          { title: t('administrationPage.tagsTitle') }
        ]}
      />
      <Grid className="administration-tags-page__container container">
        <h1 className="administration-tags-page__heading">{t('administrationPage.tagsTitle')}</h1>
        {contentItemsLoading ? (
          <p className="administration-tags-page__empty">{t('common.loading')}</p>
        ) : tagList.length === 0 ? (
          <p className="administration-tags-page__empty">{t('administrationPage.tagsEmpty')}</p>
        ) : (
          <ul className="administration-tags-page__list">
            {tagList.map(label => (
              <li className="administration-tags-page__item" key={label}>
                {label}
              </li>
            ))}
          </ul>
        )}
      </Grid>
    </Page>
  );
}
